import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function WalletSearch({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M5.38 18.12L3.5 20M3 11V6.5C3 5.11 4.11 4 5.5 4H17.5C18.88 4 20 5.11 20 6.5V9.5M20 9.5H18.5C17.11 9.5 16 10.61 16 12C16 13.38 17.11 14.5 18.5 14.5H20M20 9.5C20.55 9.5 21 9.94 21 10.5V13.5C21 14.05 20.55 14.5 20 14.5M20 14.5V17.5C20 18.88 18.88 20 17.5 20H13M7.5 13C6.70435 13 5.94129 13.3161 5.37868 13.8787C4.81607 14.4413 4.5 15.2044 4.5 16C4.5 16.7956 4.81607 17.5587 5.37868 18.1213C5.94129 18.6839 6.70435 19 7.5 19C8.29565 19 9.05871 18.6839 9.62132 18.1213C10.1839 17.5587 10.5 16.7956 10.5 16C10.5 15.2044 10.1839 14.4413 9.62132 13.8787C9.05871 13.3161 8.29565 13 7.5 13Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default WalletSearch;